import {
    CASHLIFTPARTNER_SUCCESS,
    CASHLIFTPARTNER_FAILED,
    RESET_CASHLIFTPARTNER,
    LOADING_CASHLIFTPARTNER,
    NETWORK_ERROR_CASHLIFTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetCashLiftForPartner = () => {
    return { type: RESET_CASHLIFTPARTNER };
};

const partnerCashLiftReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CASHLIFTPARTNER });
    await partnerServices
        .post("cashLiftpartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerCashLiftReqListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerCashLiftReqListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_CASHLIFTPARTNER,
                payload: err
            });
        });
};

function partnerCashLiftReqListsuccess(data) {
    return {
        type: CASHLIFTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerCashLiftReqListFailed(data) {
    return {
        type: CASHLIFTPARTNER_FAILED,
        payload: data,
    };
}

export { resetCashLiftForPartner, partnerCashLiftReqList }